import { useRef } from 'react';


export const useScrollSync = () => {
    const syncingXRef = useRef(false);
    const syncingYRef = useRef(false);

    const syncX = (source, targets) => {
        if (!Array.isArray(targets)) return;
        if (syncingXRef.current) return;
        syncingXRef.current = true;
        const x = source.scrollLeft;
        targets.forEach(t => {
            if (!t || t === source) return;
            if (t.scrollLeft !== x) t.scrollLeft = x;
        });
        syncingXRef.current = false;
    };

    const syncY = (source, targets) => {
        if (!Array.isArray(targets)) return;
        if (syncingYRef.current) return;
        syncingYRef.current = true;
        const y = source.scrollTop;
        targets.forEach(t => {
            if (!t || t === source) return;
            if (t.scrollTop !== y) t.scrollTop = y;
        });
        syncingYRef.current = false;
    };

    return { syncX, syncY };
};
